export const loadScript = (src, attrs = {}) => {
  const base = { src, type: 'text/javascript' }
  const script = Object.assign(document.createElement('script'), base, attrs)
  document.body.appendChild(script)
}
